// Vue-komponent <eui-knapp>

import { euiGeneriskKnappMixin } from 'v-mixins/euiGeneriskKnappMixin';

// Sätts av mixinen:
//// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
//let uniktIdCounter = 0;


//###################################################################################################

export default {

	name: 'eui-knapp',

	// All generisk knappfunktionalitet, se 'euiGeneriskKnappMixin.js'.
	// Props:		vpInaktiverad, vpOsynlig, vpTooltip, vpAccessKey
	// Data:			uniktId, mixinIsMounted, mixinIsMountedAndNextTick, mixinIsMountedAndSecondNextTick
	// Computed:	skaVaraOsynlig, skaVaraInaktiverad
	// Events:	tryckt
	mixins: [euiGeneriskKnappMixin],

	// @click hanterar även tryck med Enter och Mellanslag:
	// The button element has a default type of submit. You can make it do nothing by setting a type of button:

	//			this.stilTillModifierClass(vpStil),
	//		@click.stop.prevent="onButton"
	template: `
		<button
			type='button'
			:id="vpId || uniktId"
			:data-uniktid="uniktId"
			class="_eui-knapp"
			:class="[
				vpCssModifierClass,
				{
					'-inaktiverad':skaVaraInaktiverad,
					'-osynlig':skaVaraOsynlig,
				}
			]"
			:disabled="skaVaraInaktiverad"
			:title="vpTooltip"
			:aria-label="vpTooltip"
			@click.prevent="onButton"
		>
			<slot></slot>
		</button>
	`,

	// Props utöver de från mixin ovan:
	props: {
		vpId: {
			type: String,
			default: null
		},

		// Ersatt med vpCssModifierClass. Därmed har en massa kod i denna komponent också blivit överflödig (utkommenterad tills vidare):
		//vpStil: {
		//	type: String,
		//	default: ''
		//},
		vpCssModifierClass: {
			type: String,
			default: null
		},
	},

	// Data utöver de från mixin ovan:
	data() {
		return {
			//stilar: [
			//	{ stil: 'primär', cssModifierClass: '-primar' },
			//	{ stil: 'varning', cssModifierClass: '-warning' },
			//	{ stil: 'fara', cssModifierClass: '-danger' },
			//	{ stil: 'lyckat', cssModifierClass: '-success' },
			//	{ stil: 'info', cssModifierClass: '-info' },

			//	{ stil: 'länk', cssModifierClass: '-lank' },
			//	{ stil: 'transparent', cssModifierClass: '-transparent' },
			//	{ stil: 'negativ', cssModifierClass: '-negative' },
			//],
		};
	},

	//computed: {
	//},

	methods: {
		//stilTillModifierClass(stil) {
		//	// js-variant of linq firstOrDefault():https://gist.github.com/DanDiplo/30528387da41332ff22b:
		//	let stilobjekt = this.stilar.filter((item) => { return item.stil === stil; })[0] || null;

		//	if (stilobjekt === null)
		//		console.error(`Det finns ingen knappstil med namnet '${stil}'.`);
		//	else
		//		return stilobjekt.cssModifierClass;
		//},
	},
};

